import { uri } from '../utils/config';
import { HTTP } from './secure/http';

export const deleteTopping = async (placeId, toppingId) => {
  if (!placeId || !toppingId) {
    console.log('NO PLACE ID');
    return;
  }

  await HTTP.delete({
    path: `${uri.api}/place/${placeId}/toppings/${toppingId}/delete`,
  });
};